import React, { useState, useEffect } from "react";
import { Button, Col, Row, Form, Image ,Spinner} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";
import CommonModal from "../components/CommonModal";
import TextInput from "../components/TextInput";
import { IMAGES } from "../constants/images";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  loginSchema,
  userSignupSchema,
  vendorSignupSchema,
  forgotPasswordSchema,
} from "../validations/authSchema";
import { useAuth } from "../context/UserContext";
import {
  login,
  userSignup,
  forgotPassword,
  socialLogin,
  loginLinkedIn,
} from "api/authService";
import { auth, provider, signInWithPopup } from "../firebase";
import { getIndustriesList, getCompanySizesList } from "api/authService";

const Modals = ({
  modalType,
  setModalType,
  fade,
  handleShowModal,
  handleCloseModal,
  showModal1,
  handleCloseModal1,
  role,
  setRole,
  navigate,
  navigateTo = "/",
}) => {
  const location = useLocation();

  const { login: loginUser } = useAuth();
  const getValidationSchema = () => {
    if (modalType === "login") return loginSchema;
    if (modalType === "signup" && role === "vendor") return vendorSignupSchema;
    if (modalType === "signup" && role === "user") return userSignupSchema;
    if (modalType === "forgotpassword") return forgotPasswordSchema;
    return loginSchema;
  };

  const [industries, setIndustries] = useState([]);
  const [companySizes, setCompanySizes] = useState([]);
  const [verificationModal, setVerificationModal] = useState(false);
  const handleCloseVerificationModal = () => {
    setVerificationModal(false);
  };
  useEffect(() => {
    const fetchIndustries = async () => {
      const res = await getIndustriesList();
      setIndustries(res.body.data);
    };
    fetchIndustries();
  }, []);

  useEffect(() => {
    const fetchCompanySizes = async () => {
      const res = await getCompanySizesList();
      setCompanySizes(res.body.data);
    };
    fetchCompanySizes();
  }, []);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(getValidationSchema()),
  });

  const onLoginSubmit = async (data) => {
    try {
      const res = await login(data.email, data.password);
      if (res.success === true && res.code === 200) {
        loginUser(res.body.user, res.body.token); // store in context
        toast.success(res.message);
        if (handleCloseModal) {
          handleCloseModal();
        } else {
          setModalType("");
        }
        reset();
        // if (res.body.user.role === "vendor") {
        //   navigate(navigateTo);
        // } else {
        //   // navigate("/my-profile");
        // }
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.message || "Login failed");
    }
  };

  const onSignupSubmit = async (data) => {
    try {
      const findInustry= industries.find(v=>v.title=== data?.industry)
      const findCompanySize= companySizes.find(v=>v.title=== data?.companySize)
      const payload = {
        role: role,
        firstName: data?.firstName,
        lastName: data?.lastName,
        email: data?.email,
        companyName: data?.companyName,
        companyEmail: data?.companyEmail,
        industry:findInustry?._id,
        companySize: findCompanySize?._id,
        password: data?.password,
        isUpdateReceive: data?.isUpdateReceive ? "yes" : "no",
      };
      const res = await userSignup(payload);
      if (res.success === true && res.code === 200) {
        if (role === "vendor") {
          handleCloseModal();
          setVerificationModal(true);
          reset();
        } else {
          loginUser(res.body.user, res.body.token); // store in context
          toast.success(res.message);
          handleCloseModal();
          reset();
          // navigate("/my-profile");
        }
      } else {
        toast.error(res.message);
      }
    } catch (err) {
console.log('err', err)
      toast.error(err.response?.data?.message || "Signup failed");
    }
  };

  const onForgotSubmit = async (data) => {
    try {
      const res = await forgotPassword({ email: data.email });
      if (res.success === true && res.code === 200) {
        toast.success(res.message);
        handleCloseModal();
        reset();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      //console.log("user:", result);
      const user = result.user;

      const userData = {
        uniqueId: user.uid,
        firstName: user.displayName.split(" ")[0],
        lastName: user.displayName.split(" ")[1] || "",
        profileUrl: user.profileUrl || "",
        email: user.email,
        loginType: "google",
        role: role,
      };
      const res = await socialLogin(userData);
      if (res.success === true && res.code === 200) {
        loginUser(res.body.user, res.body.token); // store in context
        toast.success(res.message);
        handleCloseModal();
        reset();
        if (res.body.user.role === "vendor") {
          // navigate("/vendor/myprofile");
        } else {
          // navigate("/");
        }
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Google login failed");
      console.error(error);
    }
  };

  return (
    <>
      <CommonModal
        preventClose={modalType === "login" ? true : false}
        setModalType={setModalType}
        image
        className={`modal-fade ${fade ? "fade-out" : "fade-in"}`}
        title={
          modalType === "login" ? (
            <>
              <span>Hello,</span> Welcome Back!
            </>
          ) : modalType === "forgotpassword" ? (
            "Forgot Password"
          ) : modalType === "resetpassword" ? (
            "Reset Password"
          ) : modalType === "signup" ? (
            <>
              <span>Let's,</span> Create your account.
            </>
          ) : null
        }
        para={
          modalType === "login"
            ? "Kindly fill in your login details to proceed."
            : modalType === "forgotpassword"
              ? "Please enter your registered email address below to recover your password."
              : modalType === "resetpassword"
                ? "Please enter your details below to reset your password"
                : modalType === "signup"
                  ? "Kindly fill in your sign up details to proceed"
                  : null
        }
        body={
          <>
            {modalType === "login" ? (
              <>
                <form onSubmit={handleSubmit(onLoginSubmit)}>
                  <TextInput
                    labelText="Email"
                    type="email"
                    placeholder={"Enter Email Address"}
                    autoComplete="off"
                    {...register("email")}
                    errorMessage={errors.email?.message}
                  />
                  <TextInput
                    labelText="Password"
                    type="password"
                    placeholder="Enter Password"
                    autoComplete="new-password"
                    {...register("password")}
                    errorMessage={errors.password?.message}
                  />
                  <div className="text-end mb-4">
                    <Link
                      onClick={() => setModalType("forgotpassword")}
                      className="forgotPassword"
                    >
                      Forgot Password?
                    </Link>
                  </div>
                  <Button
                    variant="info"
                    type="submit"
                    disabled={isSubmitting}
                    // onClick={() => {
                    //     navigate("/my-profile");
                    //     // handleLogin();
                    //     handleCloseModal("");
                    // }}
                    className="w-100 border-radius-100 d-flex justify-content-center align-items-center"
                  >
                    {isSubmitting ? <Spinner animation="border" size="sm" /> : "Login"}
                  </Button>
                </form>
                {/* <Button
                                    variant="info"
                                    onClick={() => {
                                        navigate("/vendor/myprofile");
                                        // handleLogin();
                                        handleCloseModal("");
                                    }}
                                    className="w-100 border-radius-100 mt-2"
                                >
                                    Vendor Login
                                </Button> */}

                <div className="orBox">
                  <div className="divider" />
                  <span>Or Continue With</span>
                </div>

                <div className="socialBox socialBox1">
                  <Button
                    variant="outline-default"
                    className="w-100 border-radius-100"
                    onClick={handleGoogleLogin}
                  >
                    <Icon icon="flat-color-icons:google" />
                    Google
                  </Button>
                  <Button
                    onClick={async () => {
                      const res = await loginLinkedIn(location.pathname||"",role);

                    }}
                    variant="outline-default"
                    className="w-100 border-radius-100"
                  >
                    <Icon icon="devicon:linkedin" />
                    LinkedIn
                  </Button>
                </div>

              </>
            ) : null}
            {modalType === "forgotpassword" ? (
              <>
                <form onSubmit={handleSubmit(onForgotSubmit)}>
                  <TextInput
                    labelText={"Email"}
                    type="email"
                    placeholder={"Enter Email Address"}
                    {...register("email")}
                    errorMessage={errors.email?.message}
                  />
                  <Button
                    variant="info"
                    type="submit"
                    disabled={isSubmitting}
                    // onClick={() => handleShowModal("resetpassword")}
                    className="w-100 border-radius-100 d-flex justify-content-center align-items-center"
                  >
                    {isSubmitting ? <Spinner animation="border" size="sm" /> : "Continue"}
                  </Button>
                </form>
                <div className="dontAccount mt-4">
                  <p>
                    Back To{" "}
                    <Link onClick={() => setModalType("login")}>Login</Link>
                  </p>
                </div>
              </>
            ) : null}
            {modalType === "signup" ? (
              <>
                <form onSubmit={handleSubmit(onSignupSubmit)}>
                  {role === "vendor" ? (
                    <>
                      <Row>
                        <Col md={6}>
                          <TextInput
                            labelText={"First Name"}
                            type="text"
                            placeholder={"Enter First Name"}
                            {...register("firstName")}
                            errorMessage={errors.firstName?.message}
                          />
                        </Col>
                        <Col md={6}>
                          <TextInput
                            labelText={"Last Name"}
                            type="text"
                            placeholder={"Enter Last Name"}
                            {...register("lastName")}
                            errorMessage={errors.lastName?.message}
                          />
                        </Col>
                      </Row>
                      <TextInput
                        labelText="Email"
                        type="email"
                        placeholder={"Enter Email Address"}
                        {...register("email")}
                        errorMessage={errors.email?.message}
                      />
                      <TextInput
                        labelText="Company Name"
                        type="text"
                        placeholder={"Enter Company Name"}
                        {...register("companyName")}
                        errorMessage={errors.companyName?.message}
                      />
                      <TextInput
                        labelText="Company Email"
                        type="email"
                        placeholder={"Enter Company Email"}
                        {...register("companyEmail")}
                        errorMessage={errors.companyEmail?.message}
                      />
                      <Form.Group className="mb-3">
                        <Form.Label className="d-block text-start">Industry</Form.Label>
                        <Form.Select
                          {...register("industry")}
                          isInvalid={!!errors.industry}
                        >
                          <option value="">Select Industry</option>
                          {industries.map((i) => (
                            <option key={i._id} value={i.title}>
                              {i.title}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.industry?.message}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="d-block text-start">Company Size</Form.Label>
                        <Form.Select
                          {...register("companySize")}
                          isInvalid={!!errors.companySize}
                        >
                          <option value="">Select Size</option>
                          {companySizes.map((s) => (
                            <option key={s._id} value={s.title}>
                              {s.title} Employees
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.companySize?.message}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <TextInput
                        labelText="Password"
                        type="password"
                        placeholder={"Enter Password"}
                        {...register("password")}
                        errorMessage={errors.password?.message}
                      />
                    </>
                  ) : (
                    <>
                      <Row>
                        <Col md={6}>
                          <TextInput
                            labelText={"First Name"}
                            type="text"
                            placeholder={"Enter First Name"}
                            {...register("firstName")}
                            errorMessage={errors.firstName?.message}
                          />
                        </Col>
                        <Col md={6}>
                          <TextInput
                            labelText={"Last Name"}
                            type="text"
                            placeholder={"Enter Last Name"}
                            {...register("lastName")}
                            errorMessage={errors.lastName?.message}
                          />
                        </Col>
                      </Row>
                      <TextInput
                        labelText="Email"
                        type="email"
                        placeholder={"Enter Email Address"}
                        {...register("email")}
                        errorMessage={errors.email?.message}
                      />
                      <TextInput
                        labelText="Password"
                        type="password"
                        placeholder={"Enter Password"}
                        {...register("password")}
                        errorMessage={errors.password?.message}
                      />
                    </>
                  )}

                  <h5 className="text-start termsContent">
                    <Form.Check
                      type="checkbox"
                      id="terms"
                      {...register("terms")}
                      label={
                        <>
                          To continue, please agree to our{" "}
                          <Link style={{
                            textDecoration: 'none'
                          }} to="/terms-conditions" className="text-primary" target="_blank" rel="noopener noreferrer">Terms & Conditions </Link>{" "}
                          and <Link style={{
                            textDecoration: 'none'
                          }} to="/privacy-policy" className="text-primary" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>.
                        </>
                      }
                    />
                    <span className="text-danger small">
                      {errors.terms?.message}
                    </span>
                  </h5>
                  <h5 className="text-start termsContent">
                    <Form.Check
                      type="checkbox"
                      id="isUpdateReceive"
                      {...register("isUpdateReceive")}
                      label={
                        <>
                          I would like to receive updates about products,
                          solutions, and special offers from Xuthority.
                        </>
                      }
                    />
                  </h5>
                  <Button
                    // onClick={() => {
                    //     if (role === "vendor") {
                    //         showModal1(true);
                    //     }
                    //     handleCloseModal("");
                    // }}
                    type="submit"
                    disabled={isSubmitting}
                    variant="info"
                    className="w-100 border-radius-100 mt-4 d-flex justify-content-center align-items-center" 
                  >
                    {isSubmitting ? <Spinner animation="border" size="sm" /> : "Sign Up"}
                  </Button>
                </form>
                <div className="orBox">
                  <div className="divider" />
                  <span>Or Continue With</span>
                </div>

                <div className="socialBox socialBox1">
                  <Button
                    variant="outline-default"
                    className="w-100 border-radius-100"
                    onClick={handleGoogleLogin}
                  >
                    <Icon icon="flat-color-icons:google" />
                    Google
                  </Button>
                  <Button
                    variant="outline-default"
                    className="w-100 border-radius-100"
                    onClick={async () => {
                      const res = await loginLinkedIn(location.pathname||"");

                    }}
                  >
                    <Icon icon="devicon:linkedin" />
                    LinkedIn
                  </Button>
                </div>

                <div className="dontAccount">
                  <p>
                    Already have an account?{" "}
                    <Link onClick={() => setModalType("login")}>Login</Link>
                  </p>
                </div>
              </>
            ) : null}
          </>
        }
        show={modalType !== ""}
        onClose={() => {
          if (navigateTo === "/write-a-review") {
            navigate(-1);  // Go back in history
          } else {
            reset();
            handleCloseModal();  // Your regular close handler
          }
        }}
        role={role}
        setRole={setRole}
        modalType={modalType}
      
      />

      <CommonModal
        title={
          <>
            <Image src={IMAGES.Vendor_Icon5_IMG} className="proImg100" alt="" />
            <div className="d-block mt-3">Profile Verification in Progress</div>
          </>
        }
        className="loginHideModal"
        para={
          "We're reviewing your profile details to ensure everything is accurate and secure. Once verified, you'll have full access to all features and can start interacting with the community. Thank you for your patience!"
        }
        body={
          <>
            <Button
              variant="info"
              onClick={handleCloseVerificationModal}
              className=" w-100 border-radius-100"
            >
              Ok Got It
            </Button>
          </>
        }
        show={verificationModal}
        onClose={handleCloseVerificationModal}
      />
    </>
  );
};

export default Modals;
